module.exports = {
      id: "comm-women-usage",
      viewBox: "0 0 228.124 50.336",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#comm-women",
      toString: function () {
        return this.url;
      }
    }